import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import PlaceIcon from "@mui/icons-material/Place";
import { Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";
/**
 * A compact, centered display of match date, time, and optional venue information.
 * Used in match detail page headers.
 */
export const MatchDateTimeHeader = ({ kickOff, venueName, pitchName, venueLink, subtitle, }) => {
    const kickOffDate = new Date(kickOff);
    const venueText = (_jsxs(_Fragment, { children: [venueName, pitchName && ` · ${pitchName}`] }));
    return (_jsxs(Stack, { spacing: 0.5, alignItems: "center", children: [_jsx(Typography, { variant: "body2", color: "text.secondary", children: format(kickOffDate, "EEE, MMM d · h:mm a") }), venueName && (_jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", children: [_jsx(PlaceIcon, { sx: { fontSize: 14 }, color: "action" }), venueLink ? (_jsx(Typography, { component: Link, to: venueLink, variant: "caption", color: "text.secondary", sx: {
                            textDecoration: "none",
                            "&:hover": { textDecoration: "underline" },
                        }, children: venueText })) : (_jsx(Typography, { variant: "caption", color: "text.secondary", children: venueText }))] })), subtitle] }));
};
